import { createAction, props } from '@ngrx/store';
import type { ScLinkField } from '@core/jss-models';

import type {
  SolarPanelsFunnelSettingsInterface,
  SolarPanelsProductWithCalculations,
} from '../models';

const feature = 'SolarPanels';
const PREFIX = `[${feature} Funnel]`;

export type SolarPanelsFunnelStep =
  | 'wizard'
  | 'suitabilityCheck'
  | 'productOverview'
  | 'resultOverview'
  | 'orderForm';

export const initializeSolarPanelsFunnelStepAction = createAction(
  `[${feature} Funnel] Step initialized`,
  props<{
    step: SolarPanelsFunnelStep;
    funnelSettings: SolarPanelsFunnelSettingsInterface | undefined;
  }>()
);

export const clearSolarPanelsFunnelInitializedAction = createAction(
  `[${feature} Funnel]} Reset funnel initialization`
);

export const setSolarPanelsFunnelInitializedAction = createAction(
  `[${feature} Funnel] Initialize funnel`,
  props<{
    funnelSettings: SolarPanelsFunnelSettingsInterface;
  }>()
);

export const onSolarPanelsFunnelNavigationAction = createAction(
  `[${feature} Funnel]} Navigate`,
  props<{ page: ScLinkField | undefined }>()
);

export const handleSolarPanelsFunnelGenericErrorAction = createAction(
  `[${feature} Funnel]} Generic Error`
);

export const handleSolarPanelsFunnelPrivateErrorAction = createAction(
  `[${feature} Funnel]} Private Error`,
  props<{ message: string }>()
);

export const selectSolarPanelsProductAction = createAction(
  `[${feature} Funnel]} Select product`,
  props<{ product: SolarPanelsProductWithCalculations }>()
);

export const resetSolarPanelsProductSelectionAction = createAction(
  `[${feature} Funnel]} Reset product selection`
);

export const mintSolarPanelsTrackingIdAction = createAction(
  `[${feature} Funnel]} Mint E2E tracking ID`,
  props<{
    id: string;
  }>()
);

export const handleSolarPanelsFunnelAddressNotFoundErrorAction = createAction(
  `${PREFIX} Address not found Error`
);

export const setSelectedSolarPanelProductAction = createAction(
  `${PREFIX} Set solar product to order`,
  props<{ product: SolarPanelsProductWithCalculations }>()
);

export const navigateToHouseIsUnsuitablePageAction = createAction(
  `${PREFIX} Navigate to house is unsuitable page`,
  props<{ pageData?: ScLinkField }>()
);

export const navigateToHouseNotFoundPageAction = createAction(
  `${PREFIX} Navigate to house not found page`,
  props<{ pageData?: ScLinkField }>()
);

export const navigateToHouseIsMonumentPageAction = createAction(
  `${PREFIX} Navigate to house is monument page`,
  props<{ pageData?: ScLinkField }>()
);

export const navigateToHouseHasInsufficientRoofAreaPageAction = createAction(
  `${PREFIX} Navigate to house has insufficient roof area page`,
  props<{ pageData?: ScLinkField }>()
);

export const continueFlowFromSolarPanelsWizardAction = createAction(
  `${PREFIX} flow can be continued from solar panels wizard`
);

export const navigateToSuitabilityCheckPageAction = createAction(
  `${PREFIX} Navigate to suitability check page`,
  props<{ pageData?: ScLinkField }>()
);

export const navigateToProductOverviewPageAction = createAction(
  `${PREFIX} Navigate to product overview page`,
  props<{ pageData?: ScLinkField }>()
);

export const navigateToResultOverviewPageAction = createAction(
  `${PREFIX} Navigate to result overview page`,
  props<{ pageData?: ScLinkField }>()
);

export const navigateToOrderFormPageAction = createAction(
  `${PREFIX} Navigate to order form page`,
  props<{ pageData?: ScLinkField }>()
);
